export function getAdByWidthHeight(width, height)
{
    const adByWidth = DefaultAds['' + width];

    if (adByWidth)
    {
        const adByHeight = adByWidth['' + height];

        if (adByHeight)
        {
            return adByHeight;
        }
    }

    return DefaultAds['0']['0'];
}

export const DefaultAds = {
    0: {
        0: {
            src: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
            href: '/appdownload'
        }
    },
    160: {
        600: {
            src: '/images/defaultAds/160x600.jpg',
            href: '/appdownload'
        }
    },
    230: {
        33: {
            src: '/images/defaultAds/230x33.jpg',
            href: '/appdownload'
        }
    },
    300: {
        250: { src: '/images/defaultAds/300x250.jpg', href: '/appdownload' },
        600: { src: '/images/defaultAds/300x600.jpg', href: '/appdownload' }
    },
    320: {
        50: {
            src: '/images/defaultAds/320x50.jpg',
            href: '/appdownload'
        }
    },
    728: {
        90: {
            src: '/images/defaultAds/728x90.jpg',
            href: '/appdownload'
        }
    }
};

